import React, { useContext } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useLocation } from "react-router-dom";
import DarkModeRoundedIcon from "@mui/icons-material/DarkModeRounded";
import LightModeRoundedIcon from "@mui/icons-material/LightModeRounded";

import { DataContext } from "../context/DataContext";
import { simpleMessage } from "../helpers/Helpers";
import { getPageTitle } from "../helpers/pageTitles";
import { changeThemeAsync, getToken } from "../api/Account";
import SucursalSelector from "./ui/SucursalSelector";

const NavBarElements = () => {
  const token = getToken();
  const location = useLocation();

  const { isDarkMode, setIsDarkMode, setIsLoading, docTitle, selectedSucursal, sucursales } =
    useContext(DataContext);

  const changeTheme = async () => {
    setIsLoading(true);
    const resul = await changeThemeAsync(token);
    if (!resul.statusResponse) {
      setIsLoading(false);
      simpleMessage("No se pudo cambiar el tema", "error");
      return;
    }

    setIsDarkMode(!isDarkMode);
    setIsLoading(false);
  };

  const { title, sub: fallbackSub } = getPageTitle(location.pathname, docTitle);
  const sucursalActiva = sucursales.find((s) => s.id === selectedSucursal);
  const sub = sucursalActiva ? `Sucursal ${sucursalActiva.description}` : fallbackSub;

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%", gap: "20px" }}>
      <Box sx={{ minWidth: 0 }}>
        <Typography sx={{ fontFamily: "'Poppins', sans-serif", fontSize: 20, fontWeight: 600, color: "text.primary", lineHeight: 1.1 }}>
          {title}
        </Typography>
        <Typography sx={{ fontSize: 13, color: "text.disabled", marginTop: "3px" }}>{sub}</Typography>
      </Box>

      <Box sx={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "14px" }}>
        <SucursalSelector />
        <IconButton
          onClick={changeTheme}
          title="Cambiar tema"
          sx={{
            width: 42,
            height: 42,
            borderRadius: "11px",
            backgroundColor: "action.hover",
            border: "1px solid",
            borderColor: "divider",
          }}
        >
          {isDarkMode ? <LightModeRoundedIcon sx={{ fontSize: 19 }} /> : <DarkModeRoundedIcon sx={{ fontSize: 19 }} />}
        </IconButton>
      </Box>
    </Box>
  );
};

export default NavBarElements;
